/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateUserRequest { 
    id?: string;
    login?: string | null;
    firstName: string;
    lastName?: string | null;
    middleName?: string | null;
    email?: string | null;
    emailConfirmed?: boolean | null;
    phoneNumber?: string | null;
    phoneNumberConfirmed?: boolean | null;
    externalId?: string | null;
    userTypeId?: number | null;
    externalSourceId?: number | null;
    isAgreementAcceptanceRequired?: boolean;
    roleIds?: Array<string> | null;
    tenantIds?: Array<string> | null;
}

